import {Button, Col, Divider, List, Modal, Row, Switch} from "antd";
import {HistoryOutlined} from "@ant-design/icons";
import {useRecoilValue} from "recoil";
import {globalBrandConfigState, globalBrandModuleSettingState, globalWebModuleSettingState,} from "../../../_common/global_state";
import React, {useEffect, useState} from "react";
import VirtualList from "rc-virtual-list";
import useLayoutFunction, {reorderPositions} from "../../function";
import useShared from "../../../../shared/_common/_shared";
import {DragDropContext, Draggable, Droppable} from "react-beautiful-dnd";
import {useTranslation} from "react-i18next";
import {moduleTranslation} from "../../../_common/function";
import {getSettings} from "../../../router/sidebarRoute";

const EditNavigationModal_2 = (props) => {
    const {isModalOpen, handleCancel} = props;
    const {t} = useTranslation();
    const {IconCommon, IconModule, checkUserAccessRight} = useShared();
    const {saveNavigationFunction, resetNavigationFunction} = useLayoutFunction();
    
    const [userPreference, setUserPreference] = useState([]);
    const [checkedSwitches, setCheckedSwitches] = useState(userPreference?.map((item) => item?.moduleId?._id));
    const [remainAdding, setRemainAdding] = useState(0);
    const [initialUserPreference, setInitialUserPreference] = useState([]);
    
    const brandModuleSetting = useRecoilValue(globalBrandModuleSettingState);
    const webModuleSetting = useRecoilValue(globalWebModuleSettingState);
    const brandConfigState = useRecoilValue(globalBrandConfigState);

    const isLocked = (moduleName) => {
        const {accessRightID} = getSettings(moduleName, brandConfigState, brandModuleSetting);
        return accessRightID ? !checkUserAccessRight(accessRightID) : false;
    }

    const handleDragEnd = (result) => {
        if (!result?.destination) {
            return;
        }

        const {source, destination} = result;

        const findObj = userPreference?.find(
            (item) => item?.moduleId?.name === source?.droppableId
        );
        const desObj = userPreference?.find(
            (item) => item?.moduleId?.name === destination?.droppableId
        );

        if (desObj?.isLocked || findObj?.isLocked) {
            return false;
        }

        const reorderedItems = reorderPositions(userPreference, findObj?.moduleId?._id, desObj?.position);
        setUserPreference(reorderedItems);
    };

    const isModuleSelected = (id) => {
        return checkedSwitches?.includes(id);
    };

    const isSwitchDisabled = (id) => {
        const currentSwitch = brandModuleSetting?.find((item) => item?._id === id);
        const isSelected = checkedSwitches?.find((checkId) => checkId === id)?.length > 0;

        if (isSelected) {
            return false;
        } else {
            if (userPreference?.length < 5) {
                if (currentSwitch?.parent === null) {
                    return brandModuleSetting?.some((item) => item?.parent?._id === currentSwitch?._id && isModuleSelected(item?._id));
                } else {
                    return isModuleSelected(currentSwitch?.parent?._id);
                }
            } else {
                return true;
            }
        }
    };

    const remove = (id) => {
        setUserPreference((prevUserPreference) => prevUserPreference?.filter((item) => item?.moduleId?._id !== id));
        setCheckedSwitches((prevCheckedSwitches) => prevCheckedSwitches?.map((item) => {
            if (item === id) {
                return {_id: item, checked: false};
            }
            return item;
        }))
    };

    const add = (add, id) => {
        const itemToAdd = brandModuleSetting.find((item) => item?._id === id);
        if (add && !isModuleSelected(id)) {
            if (userPreference?.length < 5) {
                const newItem = {
                    moduleId: {
                        ...itemToAdd,
                    },
                    position: userPreference?.length + 1,
                    __typename: "UserWebNavigation",
                };

                setUserPreference((prevUserPreference) => [
                    ...prevUserPreference,
                    newItem,
                ]);
                setCheckedSwitches((prevCheckedSwitches) => [
                    ...prevCheckedSwitches,
                    id,
                ]);
            }
        } else if (add === false && isModuleSelected(id)) {
            setUserPreference((prevUserPreference) => prevUserPreference?.filter((item) => item?.moduleId?._id !== id));
            setCheckedSwitches((prevCheckedSwitches) => prevCheckedSwitches?.filter((item) => item !== id));
        }
    };

    const handleSave = async () => {
        await saveNavigationFunction(userPreference);
        handleCancel();
    };

    const handleReset = async () => {
        await resetNavigationFunction();
        handleCancel();
    };

    useEffect(() => {
        const filterModuleSetting = webModuleSetting.filter((item) => item?.moduleId?.isEnabled && !item?.locked && !isLocked(item?.moduleId?.name));
        setUserPreference(filterModuleSetting);
        setInitialUserPreference(filterModuleSetting);
    }, [webModuleSetting]);

    useEffect(() => {
        setCheckedSwitches(userPreference?.map((item) => item?.moduleId?._id));
        const maxAllowedItems = 5;
        const remainModule = maxAllowedItems - userPreference?.length;
        setRemainAdding(remainModule);
        return () => {
            if (!isModalOpen) {
                setUserPreference(initialUserPreference);
            }
        };
    }, [isModalOpen, userPreference]);

    return (
        <Modal
            destroyOnClose
            title={t("common.editNavigation")}
            open={isModalOpen}
            width={"60%"}
            className={"navigationModal"}
            getContainer={() => document.getElementById("layout-2")}
            footer={[
                <div className={"flex justify-between mt-6 mx-4 md:mx-0"}>
                    <div
                        key={"reset"}
                        className={"flex items-center cursor-pointer"}
                        onClick={handleReset}
                    >
                        <HistoryOutlined
                            style={{
                                verticalAlign: "-3px",
                                color: "var(--primary-text-color)",
                                marginRight: "10px",
                            }}
                        />
                        <p className={"hidden md:block"} style={{margin: 0}}>
                            {t("editNavigationModal.resetNavigationToDefault")}
                        </p>
                        <p className={"md:hidden"} style={{margin: 0}}>
                            {t("common.reset")}
                        </p>
                    </div>
                    <div className={"flex items-center cursor-pointer"}>
                        <Button
                            key={"cancel"}
                            onClick={handleCancel}
                            className={"secondary_btn"}
                        >
                            {t("common.cancel")}
                        </Button>
                        <Button key={"save"} onClick={handleSave} className={"primary_btn"}>
                            {t("common.save")}
                        </Button>
                    </div>
                </div>,
            ]}
            onCancel={handleCancel}
        >
            <Divider className={"dividerColor"}/>
            <div id={"editNavigation"}>
                <Row className={"mt-4"} gutter={[16, 16]}>
                    <Col
                        style={{paddingLeft: "1.15rem", paddingRight: "1.15rem"}}
                        xs={24}
                        md={12}
                    >
                        <div className={"flex justify-between mb-4"}>
                            <p className={"subTitle"}>
                                {t("editNavigationModal.navigationItems")}
                            </p>

                            <p className={"subTitle"}>
                                {t("editNavigationModal.NumMoreToAdd", {remainAdding})}
                            </p>
                        </div>
                        <DragDropContext onDragEnd={handleDragEnd}>
                            <div>
                                {userPreference && [...userPreference]
                                    ?.sort((a, b) => a?.position - b?.position)
                                    ?.map((item, index) => {
                                        if (item?.moduleId?.isEnabled) return (
                                            <Droppable
                                                key={item?.moduleId?.name}
                                                droppableId={item?.moduleId?.name}
                                            >
                                                {(provided) => (
                                                    <div
                                                        ref={provided.innerRef}
                                                        {...provided.droppableProps}
                                                    >
                                                        <Draggable
                                                            key={item?.moduleId?.name}
                                                            draggableId={item?.moduleId?.name}
                                                            index={index}
                                                            isDragDisabled={item?.isLocked}
                                                        >
                                                            {(provided) => (
                                                                <div
                                                                    ref={provided.innerRef}
                                                                    {...provided.draggableProps}
                                                                    className={"editNavigationList"}
                                                                >
                                                                    <div
                                                                        className={"flex *:px-3 justify-start items-center"}>
                                                                        <div className={"!w-2/12 flex-none text-center"}>
                                                                            <IconModule
                                                                                active={false}
                                                                                className={"sidebarIcon"}
                                                                                iconName={item?.moduleId?.name}
                                                                            />
                                                                        </div>
                                                                        <div className={"!w-6/12 flex-none text-start"}>
                                                                            <p>
                                                                                {t(moduleTranslation(item?.moduleId?.name))}
                                                                            </p>
                                                                        </div>
                                                                        {!item?.isLocked && (
                                                                            <>
                                                                                <div className={"!w-2/12 flex-none text-end"}>
                                                                                    <IconCommon
                                                                                        iconName={"delete"}
                                                                                        className={"sidebarIcon cursor-pointer"}
                                                                                        style={{
                                                                                            height: "1.2rem",
                                                                                            width: "1.2rem",
                                                                                        }}
                                                                                        onClick={() => remove(item?.moduleId?._id)}
                                                                                    />
                                                                                </div>
                                                                                <div className={"!w-1/12 flex-none text-end"}>
                                                                                    <div {...provided.dragHandleProps}>
                                                                                        <IconCommon
                                                                                            style={{
                                                                                                height: "1.2rem",
                                                                                                width: "1.2rem",
                                                                                            }}
                                                                                            iconName={"hamburger"}
                                                                                            className={"sidebarIcon cursor-row-resize"}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </Draggable>
                                                        {provided.placeholder}
                                                    </div>
                                                )}
                                            </Droppable>
                                        )
                                    })
                                }
                            </div>
                        </DragDropContext>
                    </Col>
                    <Col
                        style={{paddingLeft: "1.15rem", paddingRight: "1.15rem"}}
                        xs={24}
                        md={12}
                    >
                        <p className={"subTitle mb-4"}>
                            {t("editNavigationModal.itemForSelection")}
                        </p>
                        <List>
                            <VirtualList
                                data={brandModuleSetting?.filter((item) => item?.isEnabled && item?.parent === null)}
                                height={"60vh"}
                                itemHeight={47}
                                itemKey={"stock"}
                            >
                                {(item) => {
                                    const isOpen = webModuleSetting?.find((items) => items?.moduleId?.name === item?.name);
                                    const isSelected = checkedSwitches?.find((items) => items === item?._id)?.length > 0;

                                    if (isOpen?.locked || isLocked(item?.name)) return <div key={item?._id}></div>;

                                    let children = [];

                                    brandModuleSetting?.map((items) => {
                                        if (items?.parent?._id === item?._id && items?.isEnabled) {
                                            children?.push(items);
                                        }
                                    });

                                    return (
                                        <>
                                            <div className={"editNavigationList"}>
                                                <Row gutter={[16, 16]} className={"items-center"}>
                                                    <Col span={4} className={"text-center"}>
                                                        <IconModule
                                                            active={false}
                                                            className={"sidebarIcon"}
                                                            iconName={t(item?.name)}
                                                        />
                                                    </Col>
                                                    <Col span={16}>
                                                        <p>{t(moduleTranslation(item?.name))}</p>
                                                    </Col>
                                                    <Col span={4}>
                                                        <Switch
                                                            size={"small"}
                                                            defaultChecked={isOpen}
                                                            checked={isSelected}
                                                            onChange={(e) => add(e, item?._id)}
                                                            disabled={isSwitchDisabled(item?._id) || isOpen?.isLocked}
                                                        />
                                                    </Col>
                                                </Row>
                                            </div>
                                            {children?.length > 0 && children.map((item) => {
                                                const isSelected = checkedSwitches?.find((items) => items === item?._id)?.length > 0;
                                                const isOpen = webModuleSetting?.find((items) => items?.moduleId?.name === item?.name);

                                                if (isOpen?.locked || isLocked(item?.name)) return <div key={item?._id}></div>;

                                                return (
                                                    <div className={"editNavigationList"}>
                                                        <Row
                                                            gutter={[16, 16]}
                                                            className={"items-center"}
                                                        >
                                                            <Col span={7} className={"text-end"}>
                                                                <IconModule
                                                                    active={false}
                                                                    className={"sidebarIcon"}
                                                                    iconName={t(item?.name)}
                                                                />
                                                            </Col>
                                                            <Col span={13}>
                                                                <p>{t(moduleTranslation(item?.name))}</p>
                                                            </Col>
                                                            <Col span={4}>
                                                                <Switch
                                                                    size={"small"}
                                                                    defaultChecked={isOpen}
                                                                    checked={isSelected}
                                                                    onChange={(e) => add(e, item?._id)}
                                                                    disabled={isSwitchDisabled(item?._id) || isOpen?.isLocked}
                                                                />
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                );
                                            })}
                                        </>
                                    );
                                }}
                            </VirtualList>
                        </List>
                    </Col>
                </Row>
            </div>
        </Modal>
    );
};

export default EditNavigationModal_2;
